<template>
	<div id="login">
		<b-container>
			<b-row align-v="center">
				<b-col></b-col>
				<b-card no-body class="overflow-hidden margin-top" style="max-width: 540px;">
					<b-row no-gutters>
						<b-col md="6">
							<img
								src="../../assets/APP_logo.jpg"
                style="width:100%;"
							/>
						</b-col>
						<b-col md="6">
							<b-card-body title="Log In">
								<div v-if="isNotLoggedIn">
									<ul>
										<li v-for="(error, index) in errors.all()" :key="index">{{ error }}</li>
									</ul>
									<b-input-group prepend="Email" class="mt-3">
										<b-form-input v-model="user.email" v-validate="'required|email'" type="email"/>
									</b-input-group>
									<b-input-group prepend="Password" size="sm" class="mt-4">
										<b-form-input v-model="user.password" v-validate="'required|min:4'" type="password"/>
									</b-input-group>
									<br>
									<b-button @click="login()" variant="primary">LOGIN</b-button>
								</div>
								<div v-else>
									<button @click="logout">LOGOUT</button>
								</div>
							</b-card-body>
						</b-col>
					</b-row>
				</b-card>
				<b-col></b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import router, { Auth } from "../../router";
import api from "../../api";
import cookieToken from "../../utils/cookieToken";
export default {
	name: "login",
	data() {
		return {
			user: {
				email: "",
				password: ""
			}
		};
	},
	mounted() {
		if (cookieToken.getCookie() !== null) {
			this.tokenLogin();
		}
	},
	computed: {
		isNotLoggedIn() {
			return true;
		}
	},
	methods: {
		login: function() {
			api.login(this.user.email, this.user.password).then(response => {
				Auth.login(response.data[0].token);
				router.push(this.$route.query.redirect);
			});
		},
		tokenLogin: function() {
			Auth.tokenLogin();
			router.push(this.$route.query.redirect);
		}
	}
};
</script>

<style lang='css'>
#login {
	color: #53574D;
}
.margin-top {
	margin-top: 20%;
}
</style>
